export class GameColours {
    constructor() { }
}
GameColours.WHITE = "#ffffff";
GameColours.PURPLE = "#45127f";
GameColours.PINK = "#f001d8";
GameColours.BLUE = "#0078ff";
//# sourceMappingURL=GameColours.js.map